<template>
  <div class="wrapper" v-if="ready">
    <div class="animated fadeIn">
      <div class="my-2" slot="header">
        <h1 class="text-uppercase font-weight-bold">
          Proceso #{{ process.number }}
          <process-options :process_options="process_options"></process-options>
        </h1>

        <strong>
          <i class="fa fa-angle-right"></i>
          {{ process.sag_filter.origin_name }} <i class="fa fa-angle-right"></i> {{ process.sag_filter.variety_name }}
          <i class="fa fa-angle-right"></i>
          {{ process.sag_filter.condition }}
          <b-spinner v-if="loading" class="float-right" small></b-spinner>
        </strong>
      </div>
      <b-row>
        <b-col class="mb-3">
          <main-buttons @add-rows-in="addRowsIn($event)" />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <content-table
            :title="'Pallets/Bins Volteados'"
            :items="contents_in"
            :footers="footers_in"
            :table_type="0"
            @delete-row="deleteRow($event)"
            :fields="fields_in"
          />
        </b-col>
      </b-row>
      <b-row v-if="process_options.square_by_lot">
        <b-col>
          <h3>Lotes en Proceso</h3>
          <lot-list :lotsInProcess="lotsInProcess"></lot-list>
        </b-col>
      </b-row>
      <b-row v-if="!process_options.square_by_lot" class="mb-2">
        <b-col>
          <h3>Crear Productos Resultantes</h3>
          <create-content-buttons
            :lot="currentLotInProcess.lot_number"
            :lot_id="currentLotInProcess.lot_id"
            :product_id="currentLotInProcess.product_id"
            :net_kilograms_sum_in="totalInNet"
            :net_kilograms_sum_out="totalOutNet"
            :product_set="{}"
          ></create-content-buttons>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <content-table
            :title="'Pallets/Bins Resultantes'"
            @delete-row="deleteRow($event)"
            :footers="footers_out"
            :table_type="1"
            :items="contents_out"
            :fields="fields_out"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col class="mb-3">
          <b-button
            variant="primary"
            :disabled="loading || differenceNet != 0"
            v-b-modal.close-process-modal
            class="float-right"
          >
            <span class="mr-1">Cerrar Proceso</span>
            <b-spinner v-if="loading" variant="light" class="float-right" small></b-spinner>
          </b-button>
          <b-modal
            id="close-process-modal"
            @ok="onSubmit"
            :ok-disabled="loading || differenceNet != 0"
            title="Cerrar proceso"
            size="sm"
            class="modal-primary"
          >
            <b-form-group v-if="userHasScope('edit-process-end-time')">
              <template>
                <label> Ingrese fecha fin de proceso </label>
                <datetime
                  type="datetime"
                  v-model="end_time"
                  required
                  auto
                  :minute-step="10"
                  aria-describedby="input-inputFechaTermino-live-feedback"
                  input-class="form-control"
                  class="theme-orange"
                >
                </datetime>
              </template>
            </b-form-group>
            <!-- Notes -->
            <b-form-group>
              <label> Notas </label>
              <b-form-textarea
                v-model="notes"
                placeholder="Ingrese notas"
                rows="3"
                max-rows="6"
                aria-describedby="input-inputNotas-live-feedback"
                input-class="form-control"
                class="theme-orange"
              >
              </b-form-textarea>
            </b-form-group>
          </b-modal>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import MainButtons from "./MainButtons";
import ContentTable from "./ContentTable";
import ProcessOptions from "./ProcessOptionsModal";
import CreateContentButtons from "./CreateContentButtons";
import LotList from "./LotList";
import { mapGetters, mapState } from "vuex";
import userHasScope from "../../utils/userHasScope";
export default {
  name: "Main",
  components: {
    MainButtons,
    ContentTable,
    ProcessOptions,
    CreateContentButtons,
    LotList
  },
  async mounted() {
    if (localStorage.getItem("ppo.square_by_lot")) {
      this.process_options.square_by_lot = localStorage.getItem("ppo.square_by_lot") === "true";
    } else {
      this.process_options.square_by_lot = true;
    }
    if (localStorage.getItem("ppo.sag_filter")) {
      this.process_options.sag_filter = localStorage.getItem("ppo.sag_filter") === "true";
    } else {
      this.process_options.sag_filter = true;
    }
    await this.getProcess(this.$route.params.id);
    this.end_time = this.process.end_time;
  },
  computed: {
    ...mapState("alfaberriesProcess", {
      contents_in: (state) => state.form.contents_in,
      contents_out: (state) => state.form.contents_out
    }),
    ...mapGetters("alfaberriesProcess", [
      "totalInNet",
      "totalOutNet",
      "totalInQuantity",
      "totalOutQuantity",
      "differenceNet",
      "lotsInProcess",
      "currentLotInProcess"
    ]),
    footers_in() {
      return {
        net_kilograms: this.totalInNet,
        quantity: this.totalInQuantity
      };
    },
    footers_out() {
      return {
        net_kilograms: this.totalOutNet,
        quantity: this.totalOutQuantity
      };
    }
  },
  data() {
    return {
      ready: false,
      title: "Ingreso",
      process: null,
      process_options: {
        square_by_lot: null,
        sag_filter: null
      },
      loading: false,
      end_time: null,
      notes: null,
      fields_in: [
        { key: "pallet_number", label: "#" },
        { key: "lot_number", label: "Lote" },
        {
          key: "quantity",
          label: "Cantidad",
          tdClass: "text-right",
          thClass: "text-right"
        },
        {
          key: "net_kilograms",
          label: "KN",
          tdClass: "text-right",
          thClass: "text-right"
        },
        {
          key: "action",
          label: "",
          tdClass: "text-right",
          thClass: "text-right"
        }
      ],
      fields_out: [
        { key: "pallet_number", label: "#" },
        { key: "lot_number", label: "Lote" },
        { key: "product_type_name", label: "Tipo" },
        { key: "container_name", label: "Formato/Recipiente" },
        {
          key: "quantity",
          label: "Cantidad",
          tdClass: "text-right",
          thClass: "text-right"
        },
        {
          key: "net_kilograms",
          label: "KN",
          tdClass: "text-right",
          thClass: "text-right"
        },
        {
          key: "action",
          label: "",
          tdClass: "text-right",
          thClass: "text-right"
        }
      ]
    };
  },
  methods: {
    userHasScope: userHasScope,
    onSubmit() {
      if (this.differenceNet != 0) {
        this.$swal.fire("Debes cuadrar el proceso.", "", "warning");
        return;
      } else {
        this.closeProcess();
      }
    },
    async addRowsIn(e) {
      const thisV = this;
      thisV.loading = true;
      try {
        const response = await thisV.$axios({
          method: "POST",
          url: `api/v1/process/traceability_in/`,
          data: {
            pallet_number: e.pallet_number,
            process_id: thisV.process.id
          }
        });
        if (thisV.contents_in.find((x) => x.id === response.data.id) == null) {
          thisV.$store.commit("alfaberriesProcess/addRowsIn", response.data);
          thisV.$toast.success("Agregado con éxito", "");
          thisV.loading = false;
        } else {
          thisV.$toast.error("Este objeto ya fue ingresado", "");
          thisV.loading = false;
        }
      } catch (error) {
        console.log(error);
        this.$toast.error(error.response.data.detail, "");
        thisV.loading = false;
      }
    },
    async deleteRow(evt) {
      const thisV = this;
      let url = "";
      thisV.loading = true;
      if (evt.table === 0) {
        let indice2 = this.contents_out.findIndex((data) => data.lot_id === evt.item.lot_id);
        if (indice2 >= 0) {
          thisV.loading = false;
          this.$swal.fire(
            "Para realizar esta operación debe eliminar primero los bins y pallets resultantes del lote " +
              evt.item.lot,
            "",
            "error"
          );
        } else {
          url = `api/v1/process/delete_traceability/`;
          try {
            const response = await thisV.$axios({
              method: "POST",
              url: url,
              data: {
                process_id: thisV.process.id,
                content_id: evt.item.id,
                content_type: 2
              }
            });
            thisV.$store.commit("alfaberriesProcess/deleteRow", {
              table_type: evt.table,
              item: response.data,
              index: evt.index
            });
            thisV.$toast.success("Eliminado con éxito", "");
            thisV.loading = false;
          } catch (error) {
            console.log(error);
            this.$toast.error(error.response.data.detail, "");
            thisV.loading = false;
          }
        }
      } else {
        url = `api/v1/process/delete_traceability/`;

        try {
          const response = await thisV.$axios({
            method: "POST",
            url: url,
            data: {
              process_id: thisV.process.id,
              content_id: evt.item.id,
              content_type: 1
            }
          });
          thisV.$store.commit("alfaberriesProcess/deleteRow", {
            table_type: evt.table,
            item: response.data,
            index: evt.index
          });
          thisV.$toast.success("Eliminado con éxito", "");
          thisV.loading = false;
        } catch (error) {
          console.log(error);
          this.$toast.error(error.response.data.detail, "");
          thisV.loading = false;
        }
      }
    },
    async getProcess(evt) {
      const thisV = this;
      let url = "";
      thisV.loading = true;
      url = `api/v1/process/${evt}/detailed_production_plan_process/`;
      try {
        const response = await thisV.$axios({
          method: "GET",
          url: url
        });
        thisV.$store.commit("alfaberriesProcess/updateProcess", response.data);
        thisV.process = response.data;
        thisV.notes = response.data.note;
        thisV.$toast.success(`Proceso #${evt} cargado con éxito`, "");
        thisV.loading = false;
      } catch (error) {
        console.log(error);
        this.$toast.error(error.response.data.detail, "");
        thisV.loading = false;
      }
      this.$nextTick(() => {
        thisV.ready = true;
      });
    },
    async closeProcess() {
      const thisV = this;
      let url = "";
      thisV.loading = true;
      const form = {
        id: thisV.process.id,
        end_time: this.end_time,
        notes: this.notes,
        edit_process: false
      };

      url = "/api/v1/process/finish_process/";
      try {
        const response = await thisV.$axios({
          method: "PUT",
          url: url,
          data: form
        });
        thisV.loading = false;
        thisV.$router.push("/procesos/listado");
        thisV.$swal.fire("Proceso cerrado con éxito", "", "success");
      } catch (error) {
        thisV.$toast.error(error.response.data.detail, "Error");
        console.log(error.response);
        thisV.loading = false;
      }
    }
  }
};
</script>

<style scoped></style>
